import { Component, Input, OnInit } from '@angular/core';
import { UiService } from '../../../../../core/services/core.ui.service';
import { TrackerRest } from '../../../services/tracker.rest';
import { ModalComponent } from '../../../../../core/config/core.modal-helpers';

@Component({
  selector: 'tracker-query-delete',
  template: require('./tracker.query.delete.component.html'),
})
export class TrackerQueryDeleteComponent extends ModalComponent implements OnInit {
  @Input() query: any;
  @Input() refresh: Function;

  constructor(private uiService: UiService, private trackerRest: TrackerRest) {
    super();
  }

  ngOnInit() {
  }

  cancel() {
    this.closeModal();
  }

  deleteQuery() {
    this.trackerRest.deleteQuery(this.query.tracker.id, this.query.id)
      .then(() => {
        this.uiService.message.showSuccess(`Query ${this.query.queryName} has been successfully deleted`);
      })
      .catch(() => {
        this.uiService.message.showError(`Query ${this.query.queryName} could not be deleted`);
      })
      .finally(() => {
        if (this.refresh) this.refresh();
        this.closeModal();
      });
  }
}
